<template>
  <div
    id="squarebox"
    class="squarebox-section"
  >
    <div class="container">
      <h2
        class="banner-text"
        v-html="section.title"
      />
      <div class="squarebox">
        <div
          v-for="info of section.info"
          :key="info.date"
          class="info"
        >
          <div
            class="number"
            v-text="info.number"
          />
          <div
            class="text"
            v-html="info.content"
          />
        </div>
        <div class="button-holder">
          <a
            class="link btn"
            href="javascript:void(0);"
            @click="$emit('play-now-clicked')"
          >
            Play now
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import stripBlockTags from '@/utils/strip-block-tags';

export default {
  name: 'BannerLikeSection',

  props: {
    section: { type: Object, required: true }
  },

  methods: {
    stripBlockTags
  }
};
</script>

<style lang="scss" scoped>
.squarebox-section {
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 50px 0;

  .container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border: #706060 solid 6px;
    gap: 20px;
    padding: 50px 0 !important;
  }

  @media screen and (min-width: $breakpoint-md) {
    padding: 0;
  }

  h2::v-deep {
    font-size: 48px;
    line-height: 48px;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    margin: 0;
    margin-bottom: 30px !important;
    padding: 0 15px;

    @media screen and (min-width: $breakpoint-sm) {
      padding: 0 62px;
    }

    @media screen and (min-width: $breakpoint-md) {
      font-size: 80px;
      line-height: 80px;
      margin-bottom: 0 !important;
    }

    strong {
      color: $thd-orange;
    }
  }

  .squarebox {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 0 15px;

    @media screen and (min-width: $breakpoint-sm) {
      padding: 0 62px;
    }

    .info {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 20px;

      .number {
        font-size: 64px;
        line-height: 64px;
        font-weight: 700;
      }

      .text {
        font-size: 28px;
        line-height: 36px;
        font-weight: 600;
      }
    }
  }
}
</style>
